exports.init = function ($) {
  const dataRelation = {
    '#grill-icon': '#grill-info',
    '#pan-icon': '#pan-info',
    '#stove-icon': '#stove-info',
    '#microwave-icon': '#microwave-info',
    '#broil-icon' : "#broil-info",
    '#bake-icon' : "#bake-info"
  }

  let initialTrigger = false;
  const headerElem = $('#prep-info .header');

  for (const data in dataRelation) {
    $(`${data}`).on('click', function () {
      if (!initialTrigger) {
        headerElem.slideUp();
        $(`${dataRelation[data]}`).slideDown();
        initialTrigger = true;
        $(`${data}`).addClass('selected');
      } else {
        if ($(`${dataRelation[data]}`).css('display') == 'block') {
          headerElem.slideDown();
          $(`${dataRelation[data]}`).slideUp();
          initialTrigger = false;
          $(`${data}`).removeClass('selected');
        } else {
          $('.svg-container').removeClass('selected');
          $('.prep-method-description').css('display', 'none');
          $(`${dataRelation[data]}`).css('display', 'block');
          $(`${data}`).addClass('selected');
        }
      }
    })
  }

  $('.prep-method-description .close-prep').on('click', function () {
    initialTrigger = false;
    $('.prep-method-description').slideUp();
    headerElem.slideDown();
    $('.svg-container').removeClass('selected');
  });
};